import { MACHINE_SERVICE_TYPES } from '../../constants';

export const isServiceDocketLabelPrintOnly = docket => Boolean(docket?.machineServiceType === MACHINE_SERVICE_TYPES.REPAIR ||
	(docket?.packTags || []).some(tag => tag?.labelPrintOnly));

export const getServiceDocketLabelType = docket => (
	docket?.machineServiceType === MACHINE_SERVICE_TYPES.REPAIR ? 'REPAIR' : 'PACK'
);
